/*
 * 版权所有 (c) 华为技术有限公司 2024
 * Copyright (c) Huawei Technologies Co., Ltd. 2024. All rights reserved.
 */
import { type OnInit, Component, EventEmitter, Injector, Input, Output } from '@angular/core';
import { I18nService } from '@dm/core';
import { SYSTEM_VSTORE_ID } from 'app/common/constants';
import { type FileSystem, type NFSClient } from 'app/common/types/mo';

import { FileSystemEntryE } from '../../../file-system/create-file-system/create-file-system.component';
import { CreateStyleE } from '../../share.enum';
import { ClientNfsShareService } from '../client-nfs-share/client-nfs-share.service';
import { CopyFromNfsShareComponent } from '../copy-from-nfs-share/copy-from-nfs-share.component';
import { NfsShareService } from '../nfs-share.service';
import { NfsShareStrService } from '../nfs-share-str.service';

@Component({
    selector: 'app-copy-from-nfs-share-s',
    templateUrl: './copy-from-nfs-share-s.component.html',
    styleUrls: ['./copy-from-nfs-share-s.component.scss'],
})

export class CopyFromNfsShareSComponent extends CopyFromNfsShareComponent implements OnInit {
    @Input() isExistNfs = false;
    @Input() supportConfigPermission = true;
    @Input() fileSystem: FileSystem = {};
    @Output() nfsShareSwitchUpdate = new EventEmitter();
    @Output() nfsSharePermissionUpdate = new EventEmitter();

    i18nLabel = {
        nfsShareTitle: this.i18nService.get('common.nfsShare_lab'),
        permissionTitle: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_lab'),
        allUserLab: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allClients_value'),
        manuUserLab: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_manualClient_value'),
        allUserLabTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allClients_tip'),
        allUserLabReadOnlyTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_allClients_interFS_tip'),
        manuUserLabTip: this.i18nService.get('service.share_simplifiedMode_create_accessPermission_manualClient_tip'),
    };

    supportSmartGui = false;
    isCopyFrom = false;
    vstoreId = SYSTEM_VSTORE_ID;

    // 客户端列表
    clientList: NFSClient[] = [];
    entry = FileSystemEntryE.Main;
    FileSystemEntryE = FileSystemEntryE;

    showNfsShareName = '';

    constructor(
        injector: Injector,
        public str: NfsShareStrService,
        public service: NfsShareService,
        public clientNfsShareService: ClientNfsShareService,
        public i18nService: I18nService,
    ) {
        super(injector, str, service, clientNfsShareService);
    }

    ngOnInit(): void {
        super.ngOnInit();

        if (this.fileSystem?.NAME) {
            this.changeSharePath(this.fileSystem?.NAME);
        }
    }

    initVm(): void {
        super.initVm();

        this.vm.patchValue({
            NFScreateStyle: CreateStyleE.All,
        });

        // 客户端默认值
        this.clientList = this.createShare[this.vm.value.NFScreateStyle].permissions;

        super.onSwitchChange(this.switch);
    }

    onSwitchChange($event): void {
        super.onSwitchChange($event);

        this.nfsShareSwitchUpdate.emit();
    }

    /**
     *  文件系统名改变的时候，自动组装path
     * @param fsName
     * @returns
     */
    changeSharePath(fsName: string): void {
        if (!fsName) {
            return;
        }

        super.changeSharePath(fsName);

        this.showNfsShareName = `/${fsName}`;
    }

    /**
     * 更新nfs共享名称
     * @param nfsShareName
     * @returns
     */
    updateNfsShareName(nfsShareName: string): void {
        if (!nfsShareName) {
            return;
        }
        this.createShare.all.share.NAME = nfsShareName;
        this.createShare.new.share.NAME = nfsShareName;
        this.createShare.copyFrom.share.NAME = nfsShareName;
    }

    /**
     * 权限判断
     * @param value
     */
    onPermissionCreateStyleChange(value: CreateStyleE): void {
        if (value === CreateStyleE.All) {
            this.permissionIsDefault = true;
        } else {
            this.permissionIsDefault = false;
        }

        this.nfsSharePermissionUpdate.emit();
    }

    /**
     * 客户端信息更新
     * @param tableData
     */
    onTableClientNfsChange(tableData: NFSClient[]): void {
        const style = this.vm.value.NFScreateStyle;
        this.createShare[style].permissions = tableData;
    }
}
